import * as React from 'react';
import { TemplatesTable } from '../components/templatesTable';
import TemplateModalContent from '../components/TemplateModalContent';
import { CATEGORIES, SUB_CATEGORIES } from '../../../config/Categories';

import { TableItem, TemplateColNames } from '../components/cols';
import { Template } from '../../../lib/store/templates/types';
import { Category } from '../../common/categoryUtils';
import { getFilterCategoriesByTabName } from 'webapp-genric/dist/filters';
import { TAB_NAME } from 'webapp-genric/dist/constants';

interface IProps {
  showTemplateModal: Template | null;
  savingTemplate: boolean;
  toggleTempModal: (template: Template) => void;
  onSaveTemplate: (template: Template) => void;
  onSaveAndPublish: (template: Template) => void;
  categories: Category[];
  fetchingTemplates: boolean;
  tableData: TableItem[];
  templateFilter: React.ReactNode;
}
interface IState {}

export class InsightsFix extends React.Component<IProps, IState> {
  render() {
    return (
      <div>
        {this.props.showTemplateModal && (
          <TemplateModalContent
            isFetching={this.props.savingTemplate}
            categories={CATEGORIES}
            subCategories={SUB_CATEGORIES}
            templateDef={this.props.showTemplateModal}
            closePopup={this.props.toggleTempModal}
            onSave={this.props.onSaveTemplate}
            onSaveAndPublish={this.props.onSaveAndPublish}
          />
        )}
        <TemplatesTable
          options={this.props.templateFilter}
          title={'All Insights Templates'}
          categories={this.props.categories}
          filterCategories={getFilterCategoriesByTabName(TAB_NAME.INSIGHTS)}
          fields={[
            TemplateColNames.TEMPLATE_NAME,
            TemplateColNames.LINKED_TEMPLATES,
            TemplateColNames.TEMPLATE_PRIORITY,
            TemplateColNames.TEMPLATE_OPT,
          ]}
          tableData={this.props.tableData}
          fetching={this.props.fetchingTemplates}
        />
      </div>
    );
  }
}
